import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=1f088549&scoped=true&"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=1f088549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f088549",
  null
  
)

export default component.exports